import { customElement, state } from "lit/decorators.js";
import { connect } from "pwa-helpers";
import store from "../../store/store";
import { BaseComponent } from "../base-component/base-component";
import { SharpenProductData } from "./interfaces/sharpen-search-service-product-data.interface";
import { StoreState } from "../../store/store.interface";
import { getCurrentSelectedSharpenUpsellData } from "./store/sharpen-product-data.selector";
import { html, nothing } from "lit";

@customElement('mhecomm-selected-sharpen-product-isbn')
export class SelectedSharpenProductIsbn extends connect(store)(BaseComponent) {
  @state()
  private selectedSharpenProduct?: SharpenProductData;

  stateChanged(state: StoreState) {
    this.selectedSharpenProduct = getCurrentSelectedSharpenUpsellData(state);
  }

  renderComp() {
    return html`
      ${this.selectedSharpenProduct
        ? html`
        <p 
          class="py-2 mb-0"
          aria-live="polite"
          aria-atomic="true"
          aria-label="MHID: ${this.selectedSharpenProduct?.isbn} and ISBN13: ${this.selectedSharpenProduct?.isbn13}"
        >
          <span class="fw-semibold">ISBN10:</span> ${this.selectedSharpenProduct?.isbn} | 
          <span class="fw-semibold">ISBN13:</span> ${this.selectedSharpenProduct?.isbn13}
        </p>`
        : nothing
      }
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-selected-sharpen-product-isbn': SelectedSharpenProductIsbn;
  }
}
